import { stripEditorHtml } from "../lib/richTextEditor";

/**
 * Applicant-facing rejection letter (HTML from API).
 */
export default function ApplicantRejectionLetter({ letterHtml, className = "" }) {
  const html = String(letterHtml || "").trim();
  if (!html) return null;

  if (stripEditorHtml(html)) {
    return (
      <div
        className={`applicant-rejection-letter job-body-html${className ? ` ${className}` : ""}`}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  return null;
}
